var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useTheme } from "../../hooks";
import { CintLogo } from './CintLogo';
import { LucidLogo } from './LucidLogo';
var Logos = {
    CINT: CintLogo,
    LUCID: LucidLogo
};
export var Logo = function (props) {
    var theme = useTheme();
    var SelectedLogo = (props === null || props === void 0 ? void 0 : props.selectedTheme) ? Logos["" + props.selectedTheme]
        : Logos[theme.template];
    return React.createElement(SelectedLogo, __assign({}, props));
};
//# sourceMappingURL=Logo.js.map